import { render, staticRenderFns } from "./DoctorDetails.vue?vue&type=template&id=79cb23cd&scoped=true"
import script from "./DoctorDetails.vue?vue&type=script&lang=js"
export * from "./DoctorDetails.vue?vue&type=script&lang=js"
import style0 from "./DoctorDetails.vue?vue&type=style&index=0&id=79cb23cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cb23cd",
  null
  
)

export default component.exports